module.exports = __webpack_public_path__ + "static/media/logo.20d47050.png";